import { Environment } from './environment.interface';

export const environment: Environment = {
  isProduction: false,
  isLocal: false,
  baseApiUrl: 'https://api-qa.aspose.app/imaging/common/api/',
};
